import { i18n } from '@lingui/core';

export interface BinderCostRecordPageParams extends Record<string, string | undefined> {
  projectId: string;
}

export const PROJECT_PARAM_IDENTIFIER = ':projectId';

export const ROUTE_PATH = `/projects/${PROJECT_PARAM_IDENTIFIER}/binder-cost-records`;
export const TITLE = i18n._('Binder Cost Records');
